module.exports = __webpack_public_path__ + "img/813930.ccd93c05.jpg";